import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
    FaCity, FaMapMarkerAlt, FaMoneyBillWave, FaBuilding, FaBed,
    FaBath, FaVectorSquare, FaFilter, FaTimes, FaWarehouse, FaCouch
} from "react-icons/fa";
import { getAllProjects } from "../../../services/projectService";

const filterList = [
    { label: "Khu đô thị", icon: <FaCity />, key: "projectId" },
    { label: "Tỉnh/Thành phố", key: "location", icon: <FaMapMarkerAlt /> },
    { label: "Giá", key: "price", icon: <FaMoneyBillWave /> },
    { label: "Diện tích", key: "area", icon: <FaVectorSquare /> },
    { label: "Số phòng ngủ", key: "bedrooms", icon: <FaBed /> },
    { label: "Số phòng tắm", key: "bathrooms", icon: <FaBath /> },
    { label: "Loại hình", key: "propertyType", icon: <FaBuilding /> },
    { label: "Tình trạng", key: "status", icon: <FaWarehouse /> },
    { label: "Nội thất", key: "furniture", icon: <FaCouch /> },
];

export default function SidebarFilter({ filters, setFilters }) {
    const [expandedFilter, setExpandedFilter] = useState(null);
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const data = await getAllProjects({ page: 1, limit: 100 });
                const projectList = data.projects || [];
                setProjects(projectList.map(p => ({ value: p.id, label: p.name })));
            } catch (error) {
                console.error("Lỗi load dự án:", error);
                setProjects([]);
            }
        };
        fetchProjects();
    }, []);

    const toggleFilter = (key) => setExpandedFilter(prev => (prev === key ? null : key));

    const handleInput = (field, value) => {
        setFilters({ [field]: value }); // Chỉ gửi filter này → merge URL trong PropertySearchPage
    };

    const handleClearFilters = () => {
        setFilters({}); // Clear URL → filters sẽ reset
        setExpandedFilter(null);
    };

    const filterContent = (
        <div className="w-64 bg-white rounded-xl shadow p-4 space-y-3">
            <div className="flex items-center justify-between mb-4">
                <h2 className="font-bold text-lg text-blue-900">BỘ LỌC BẤT ĐỘNG SẢN</h2>
                <button
                    onClick={handleClearFilters}
                    className="text-sm text-red-500 hover:text-red-700 font-semibold"
                >
                    Xóa
                </button>
            </div>

            {filterList.map((filter, idx) => (
                <div key={idx} className="text-sm text-blue-900">
                    <div
                        className="flex items-center justify-between py-2 border-b cursor-pointer hover:text-blue-600"
                        onClick={() => toggleFilter(filter.key)}
                    >
                        <div className="flex items-center gap-2">{filter.icon} {filter.label}</div>
                        <span>{expandedFilter === filter.key ? "▴" : "▾"}</span>
                    </div>

                    {expandedFilter === filter.key && (
                        <div className="mt-2 pl-6">
                            {filter.key === "projectId" && (
                                <Select
                                    options={projects}
                                    placeholder="Chọn dự án"
                                    isClearable
                                    value={projects.find(p => p.value === Number(filters.projectId)) || null}
                                    onChange={option => handleInput("projectId", option ? option.value : "")}
                                    className="text-blue-900"
                                />
                            )}

                            {(filter.key === "price" || filter.key === "area") && (
                                <div className="flex gap-2 mb-2">
                                    <input
                                        type="number"
                                        placeholder="Từ"
                                        className="w-1/2 border px-2 py-1 rounded"
                                        value={filters[`${filter.key}From`] || ""}
                                        onChange={(e) => handleInput(`${filter.key}From`, e.target.value)}
                                    />
                                    <input
                                        type="number"
                                        placeholder="Đến"
                                        className="w-1/2 border px-2 py-1 rounded"
                                        value={filters[`${filter.key}To`] || ""}
                                        onChange={(e) => handleInput(`${filter.key}To`, e.target.value)}
                                    />
                                </div>
                            )}

                            {["bedrooms", "bathrooms", "location", "propertyType", "status", "furniture"].includes(filter.key) && (
                                <>
                                    {filter.key === "bedrooms" && (
                                        <input
                                            type="number"
                                            placeholder="Số phòng ngủ"
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.bedrooms || ""}
                                            onChange={(e) => handleInput("bedrooms", e.target.value)}
                                        />
                                    )}
                                    {filter.key === "bathrooms" && (
                                        <input
                                            type="number"
                                            placeholder="Số phòng tắm"
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.bathrooms || ""}
                                            onChange={(e) => handleInput("bathrooms", e.target.value)}
                                        />
                                    )}
                                    {filter.key === "location" && (
                                        <input
                                            type="text"
                                            placeholder="Nhập tỉnh/thành"
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.location || ""}
                                            onChange={(e) => handleInput("location", e.target.value)}
                                        />
                                    )}
                                    {filter.key === "propertyType" && (
                                        <select
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.propertyType || ""}
                                            onChange={(e) => handleInput("propertyType", e.target.value)}
                                        >
                                            <option value="">-- Loại BĐS --</option>
                                            <option value="apartment">Căn hộ</option>
                                            <option value="villa">Biệt thự</option>
                                            <option value="shophouse">Shophouse</option>
                                            <option value="condotel">Condotel</option>
                                            <option value="penthouse">Penthouse</option>
                                            <option value="duplex">Duplex</option>
                                        </select>
                                    )}
                                    {filter.key === "status" && (
                                        <select
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.status || ""}
                                            onChange={(e) => handleInput("status", e.target.value)}
                                        >
                                            <option value="">-- Trạng thái --</option>
                                            <option value="pending">Chờ duyệt</option>
                                            <option value="approved">Đã duyệt</option>
                                            <option value="rejected">Từ chối</option>
                                        </select>
                                    )}
                                    {filter.key === "furniture" && (
                                        <select
                                            className="w-full border px-2 py-1 rounded mb-2"
                                            value={filters.furniture || ""}
                                            onChange={(e) => handleInput("furniture", e.target.value)}
                                        >
                                            <option value="">-- Chọn nội thất --</option>
                                            <option value="full">Full nội thất</option>
                                            <option value="basic">Cơ bản</option>
                                            <option value="none">Không có nội thất</option>
                                        </select>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );

    return (
        <>
            <div className="hidden lg:block">{filterContent}</div>

            <div className="fixed bottom-4 left-4 lg:hidden">
                <button
                    className="bg-blue-600 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2"
                    onClick={() => setIsMobileOpen(true)}
                >
                    <FaFilter /> Bộ lọc
                </button>
            </div>

            {isMobileOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
                    <div className="bg-white w-72 h-full p-4 overflow-y-auto relative">
                        <button
                            className="absolute top-4 right-4 text-gray-600 hover:text-black"
                            onClick={() => setIsMobileOpen(false)}
                        >
                            <FaTimes size={20} />
                        </button>
                        {filterContent}
                    </div>
                </div>
            )}
        </>
    );
}
